import { ProductType } from 'domains/models/blog_post/productType';
import { translate } from 'infras/i18n';
import { useRouter } from 'next/router';
import { BlogItem } from 'presentations/api/schema/contents';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';
import {
  bestPracticesListPath,
  bestPracticesPath,
  engineeringListPath,
  newsListPath,
  newsPath,
  webPath,
} from 'presentations/routes/path';
import { setBreadcrumbs } from 'presentations/views/helpers/breadcrumbs';
import { useContext, useEffect, useMemo } from 'react';
import { setEvent } from 'presentations/views/helpers/analytics';

export interface Props {
  blog: BlogItem;
  populars: BlogItem[];
}

export const useBlogPage = (props: Props) => {
  const { state: serviceState } = useContext(ServicePortalContext);
  const viewer = serviceState.viewer;

  useEffect(() => {
    if (!serviceState.isInitialized) {
      return;
    }
    setEvent('read blog', {
      category: props.blog.category,
      slug: props.blog.slug,
      title: props.blog.title,
    });
  }, [serviceState.isInitialized, props.blog.id]);

  const breadcrumbs = [];
  if (props.blog.category === 'campaigns') {
    breadcrumbs.push({
      title: translate('breadcrumbs.Campaigns'),
      link: newsListPath(),
    });
  } else if (props.blog.category === 'news') {
    breadcrumbs.push({
      title: translate('breadcrumbs.News'),
      link: newsListPath(),
    });
  } else if (props.blog.category === 'engineering') {
    breadcrumbs.push({
      title: translate('breadcrumbs.Engineering'),
      link: engineeringListPath(),
    });
  } else if (props.blog.category === 'best_practices') {
    breadcrumbs.push({
      title: translate('breadcrumbs.Best Practices'),
      link: bestPracticesListPath(),
    });
  }
  const link =
    props.blog.category === 'best_practices'
      ? bestPracticesPath(props.blog.slug)
      : newsPath(props.blog.slug);

  breadcrumbs.push({
    title: props.blog.title,
    link,
  });
  const routes = setBreadcrumbs(breadcrumbs);

  const router = useRouter();
  const shareUrl = webPath(link, router.locale);
  const productType = ProductType.Scheduling;

  return {
    state: {
      viewer,
      routes,
      shareUrl,
      productType,
    },
    actions: {},
  };
};
